import { useEffect } from 'react';
import LangEnum from '../../../../../lang/LangEnum';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { useTranslation } from '../../../../translation/TranslationContext';
import { PagesById } from '../catalogProductsListV2.types';

interface UseCatalogListErrorToastParams {
  pagesById: PagesById;
}

export const useCatalogListErrorToast = ({ pagesById }: UseCatalogListErrorToastParams): void => {
  const { translate } = useTranslation();

  const hasPageError = Array.from(pagesById.values()).some((slot) => slot.status === 'error');

  useEffect(() => {
    if (hasPageError) {
      snackbarStore.handleMessage({
        type: 'error',
        message: translate(LangEnum.CATALOG_PRODUCTS_V2_LIST_ERROR),
      });
    }
  }, [hasPageError, translate]);
};
